export default __webpack_public_path__ + "static/media/rpay.8e2c919c.png";